export default __webpack_public_path__ + "static/media/bg2.327e8f70.png";